module.exports = function() {
  return new Worker(__webpack_public_path__ + "60f80e3b8d4cdee8898e.worker.js");
};